import { reactive, ref, watch } from "vue";

import { GET_SERVER_REQUEST, group_list } from "./ServerConnect";
import { filterObjects } from "./SortUtility";
import { showOneGF } from "./MapSetting";

// 초기 상태에서 빈 배열로 설정
export const state = reactive({
  map: null,
  allLocations: [],
  locations: [], // 빈 배열로 초기화
  markers: [],
  polygons: [],
  groupMarkers: [],
});
export const searchQuery = ref('');
export const searchType = ref('deviceid');
export const selectedGroup = ref('');
export const searchMin = ref();
export const searchMax = ref();
export const setRange = ref([0, 100]);
export const selectedGeoFence = ref('');
export const searchHour = ref();
export const searchMinute = ref();
export const searchSecond = ref();

export const MAX_TIME = ref(9999);

export const searchTypeList = ref([
  { name: 'deviceid', title: 'ID', inputboxtag: '검색', placeholder: 'ID 입력' },
  { name: 'devicename', title: '사용자명', inputboxtag: '검색', placeholder: '사용자명 입력' },
  // { name: 'groupname', title: '그룹명', inputboxtag: '선택', placeholder: '그룹명 선택' },
  { name: 'geofence', title: 'Geo Fence', inputboxtag: '선택', placeholder: '영역명 선택' },
  { name: 'backpack', title: 'Backpack' },
  // ...(loginId.value !== 'user'
  //   ? [
  //       { name: 'pci', title: 'PCI', inputboxtag: '선택', placeholder: 'PCI명 선택' },
  //       { name: 'rsrp', title: '신호 세기', inputboxtag: '신호 세기 범위 설정', placeholder: '신호 세기 범위 설정' },
  //       { name: 'battery', title: '배터리 잔량', inputboxtag: '배터리 잔량 범위 설정', placeholder: '배터리 잔량 범위 설정' },
  //       { name: 'lastuptime', title: '마지막 업데이트 시간', inputboxtag: '시간 설정', placeholder: '시간 설정' }
  //     ]
  //   : [])
]);

const filterTypeInit = async () => {
  resetSearch();
  switch (searchType.value) {
    case ('groupname'): {
      group_list.value = await GET_SERVER_REQUEST("group");
      selectedGroup.value = group_list.value[0].group_id;
      break;
    }
    case ('geofence'): {
      selectedGeoFence.value = state.polygons[0].geofence_id;
      showOneGF(state.polygons[0]);
      break;
    }
    case ('battery'): {
      setRange.value = [0, 100];
      searchMin.value = 0;
      searchMax.value = 100;
      break;
    }
    case ('rsrp'): {
      setRange.value = [-160, 0];
      searchMin.value = -160;
      searchMax.value = 0;
      break;
    }
  }
};

watch([searchQuery, selectedGroup, searchMax, searchMin], () => {
  filterObjects(state.locations);
});
watch([searchType], filterTypeInit);
watch([selectedGroup], filterObjects);

export const resetSearch = () => {
  searchQuery.value = '';
  selectedGroup.value = '';
  searchMin.value = null;
  searchMax.value = null;
  selectedGeoFence.value = '';
}

export const selectedSingleDevice = ref();
export const mouseHoveredDevice = ref(null);